import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import IconSearch from 'react-icons/lib/fa/search';
import debounce from 'lodash.debounce';

import Input from '../../common/Input/Input';
import { forcedSearchChange, setSearchValue, setSearchModalState } from '../../../actions/search';
import SearchFullscreen from 'components/SearchFullscreen';
import { getSearchValue, getSearch } from 'selectors/search';
import s from './styles';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.setSearchValue = debounce(this.setSearchValue, 500);
  }

  onChange = (event) => {
    const { value } = event.target;
    this.setSearchValue(value);
  };

  setSearchValue = (value) => this.props.setSearchValue(value);

  handleIconClick = (event) => {
    const { forcedSearchChange } = this.props;
    forcedSearchChange(event.target.value);
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const { forcedSearchChange } = this.props;
      const { value } = event.target;
      forcedSearchChange(value);
      document.activeElement.blur();
    }
  };

  handleWheel = (event) => {
    const { deltaY } = event;
    const menu = ReactDOM.findDOMNode(this.menuEl);
    const { clientHeight, scrollHeight, scrollTop } = menu;

    const moveUp = deltaY < 0;
    let stop;
    if (moveUp) {
      stop = scrollTop <= 0;
    } else {
      stop = scrollHeight - clientHeight - scrollTop <= 0;
    }
    if (stop) {
      event.preventDefault();
    }
  };

  onFocus = (e) => {
    e.stopPropagation();
    this.props.setSearchModalState(true);

    this.searchEl.blur();
  };

  onBlur = () => {};

  render() {
    const { className, searchValue, t, profile } = this.props;
    const searchInputProps = {
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onClickContainer: this.onFocus,
      getRef: (searchEl) => {
        this.searchEl = searchEl;
      },
      onClick: this.onFocus,
      icon: <IconSearch onClick={this.handleIconClick} className={cx(s.Icon)} />,
      defaultValue: searchValue,
      disabled: false,
    };

    return (
      <div className={cx(className, s.ContainerOuter)}>
        <SearchFullscreen onClose={() => this.props.setSearchValue('')} />
        <div className={s.ContainerInner}>
          <div className={s.Search}>
            <div className={s.OnlyMobile}>
              <div onClick={this.onFocus}>
                <IconSearch onClick={this.handleIconClick} className={cx(s.Icon)} />
              </div>
            </div>
            <div className={s.MobileHidden}>
              <Input
                {...searchInputProps}
                placeholder={t('components.header.search.title')}
                className={s.Input}
                onFocus={() => {
                  tracker.sendEvent('Web_Search');
                  trackGA(gaEvent.headerButtonsClick({ eventLabel: 'poisk', user_id: profile.id }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  search: getSearch(state),
  searchValue: getSearchValue(state),
  profile: state.profile,
});

const mapDispatchToProps = {
  setSearchValue,
  forcedSearchChange,
  setSearchModalState,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Search));



// WEBPACK FOOTER //
// ./src/components/Header/Search/Search.js